import serviceBase from '@/services/serviceBase'

class produtoService extends serviceBase {
    constructor() {
        super(process.env.VUE_APP_API_ENDPOINT)
    }

    fetchAll(pagina, search = "", categoriaId = null) {
        const filtroPagina = `pagina=${ pagina }`
        const filtroBusca = `&search=${ search }`
        const filtroCategoria = categoriaId ? `&categoriaId=${categoriaId}` : "";
        return this.get(`${ this.getSubdominio() }/produto?${filtroPagina}${filtroBusca}${filtroCategoria}`)
    }

    fetchById(id) {
        return this.get(`${ this.getSubdominio() }/produto/${ id }`)
    }

    fetchQtdEstoque(localDeEstoqueId, produtoPrincipalId, gradePrimariaId, gradeSecundariaId) {
        return this.get(`${ this.getSubdominio() }/estoque`, {
            localDeEstoqueId,
            produtoPrincipalId,
            gradePrimariaId,
            gradeSecundariaId
        })
    }
}

export default new produtoService()